import { H2 } from "@carrotfertility/carotene"
import { useStateMachine } from "components/context/stateMachine/StateMachineContext"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"
import { IlloCoinsAndBills } from "components/views/atoms/Illustrations"
import { BankInfoOptionButtons } from "../shared/BankInfoOptionButtons"
import { Steps } from "../workflow/steps"
import { getShouldFillOutBankInfo } from "derivedSelectors"
import L10n from "lib/carrot-l10n"
import React from "react"
import { useSelector } from "react-redux"
import { useEnrollmentFlowModal } from "../EnrollmentModal"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()
const ViewName = Steps.CONNECT_INSURANCE_NOT_REQUIRED

function ConnectInsuranceNotRequiredView(): JSX.Element {
  const { onExit } = useEnrollmentFlowModal()
  const needsBankInfo = useSelector(getShouldFillOutBankInfo)
  useStateMachine(ViewName, null)

  return (
    <div>
      <FlexRowCenter>
        <IlloCoinsAndBills />
      </FlexRowCenter>
      <Spacer height={3} />
      <H2 variant="primary">{l`You're all set.`}</H2>
      <Spacer height={0.5} />
      <Body color="black-80">{l`It looks like you do not have a deductible associated with your Carrot benefit. 
      That means we can start reimbursing you right away.`}</Body>
      {needsBankInfo && (
        <>
          <Spacer height={0.5} />
          <Body color="black-80">{l`Next, update your bank info so we can direct reimbursement funds to the right account.`}</Body>
        </>
      )}
      <Spacer height={3} />
      <div className="flex flex-row justify-center">
        <BankInfoOptionButtons {...{ needsBankInfo, onExit }} />
      </div>
    </div>
  )
}

export { ConnectInsuranceNotRequiredView }
